import {LIB_PREFIX} from '../../../settings';
import _u from './utils';

const FUNC_ATTR = 'func';
const IS_SHARED_ATTR = 'is-shared';
const IS_UTILS_ATTR = 'is-utils';
const OPTS_ATTR = 'opts';
const ARGS_ATTR = 'args';

const parseNormalized = (str) => {
  const jsonStr = str.replace(/'/g, '"').replace(/\r?\n|\r/g, '');
  let res;
  try {
    res = JSON.parse(jsonStr);
  } catch (ex) {
    res = new Function('return ' + str);
    res = res();
  }
  return res;
};

const parse = (elem, key, def = false) => {
  const attrs = [...elem.attributes].map((a) => a.name.replace(/\;|\:|v-bind\:/, ''));
  const pos = attrs.indexOf(key);
  let res = def;
  if (pos > -1) {
    res = (key === FUNC_ATTR ?
            elem.attributes[attrs.indexOf(key)].value :
            parseNormalized(elem.attributes[attrs.indexOf(key)].value));
  }
  return res;
};

class FunctionInvoker {
  constructor(elem) {
    this.func = parse(elem, FUNC_ATTR);
    this.isShared = parse(elem, IS_SHARED_ATTR);
    this.isUtils = parse(elem, IS_UTILS_ATTR);
    this.args = parse(elem, ARGS_ATTR, []);
    this.opts = parse(elem, OPTS_ATTR, null);
  }

  run() {
    if (!this.func) {
      throw 'Function to execute not set properly';
    }
    const funcPrefixWithShared = this.isShared ? window[LIB_PREFIX].shared : window[LIB_PREFIX];
    const func = this.isUtils ? funcPrefixWithShared.utils[this.func] : funcPrefixWithShared[this.func];

    if (!func) {
      throw `Function '${this.func}' not found.`;
    }

    const opts = this.opts;
    if (opts !== null && opts !== undefined && !_u.isObjectEmpty(opts)) {
      func(opts);
    } else {
      func.call(null, ...this.args);
    }
  }
}

const invokeSmartScripts = (element) => {
  [...new Set(element.getElementsByTagName('smart-script'))]
      .forEach((elem) => {
        new FunctionInvoker(elem).run();

        if (typeof elem.remove === 'function') {
          elem.remove();
        } else {
          elem.parentNode.removeChild(elem);
        }
      });
};

export default invokeSmartScripts;


